module.exports = __webpack_public_path__ + "img/jianlian_grey.ba30f6aa.svg";